<template>
  <v-container fluid class="background fill-height">
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3">
        <v-form @submit.prevent="login">
          <v-card dark flat color="rgba(0,0,0,0.1)">
            <v-container class="pb-2">
              <v-card-title>
                <img
                  :src="require('@/assets/logo.svg')"
                  alt="МОБИКА"
                  width="100%"
                />
              </v-card-title>
              <v-card-text class="pt-6">
                <v-text-field
                  color="white"
                  name="login"
                  label="Email"
                  type="email"
                  v-model="creds.login"
                  required
                ></v-text-field>
                <v-text-field
                  color="white"
                  id="password"
                  name="password"
                  label="Пароль"
                  type="password"
                  v-model="creds.password"
                  required
                ></v-text-field>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-checkbox
                      id="permanent"
                      label="запомнить"
                      v-model="creds.isPersistent"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-divider />
              </v-card-text>
              <v-card-actions>
                <v-btn text type="submit">Войти</v-btn>
                <v-spacer />
                <v-btn text class="opacity-2" href="https://mobika-online.ru"
                  >новый клиент</v-btn
                >
              </v-card-actions>
            </v-container>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <AppFooter />
  </v-container>
</template>

<script>
import AppFooter from "@/components/ui/AppFooter";
export default {
  name: "AuthLogin",
  components: {
    AppFooter
  },
  data() {
    return {
      creds: {
        login: "",
        password: "",
        isPersistent: false
      }
    };
  },
  computed: {},
  methods: {
    login() {
      this.$store
        .dispatch("auth/login", this.creds)
        .then(() => {
          if (this.$store.getters["auth/isLogged"]) {
            this.$router.push({ name: "home" });
          }
        })
        .catch(err => {
          console.error(err);
          if (err.response && err.response.status == 401) {
            this.$store.commit(
              "notifications/error",
              "Неверный логин или пароль"
            );
          }
        });
      return false;
    }
  }
};
</script>
<style scoped>
.background {
  background-image: url(~@/assets/bg.jpg);
  background-position: center center;
  background-size: cover;
}
</style>
